import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleLabel: {
		id: 'servicedesk-premium-landing-page.title-label',
		defaultMessage: 'Jira Service Management',
		description: 'Title for the Premium landing page.',
	},
	subtitleLabel: {
		id: 'servicedesk-premium-landing-page.subtitle-label',
		defaultMessage: 'Some Operations features are moving to Premium soon.',
		description: 'Subtitle for the Premium landing page.',
	},
	descriptionLabel: {
		id: 'servicedesk-premium-landing-page.description-label',
		defaultMessage:
			'Changes, advanced incident management and problems are moving to Premium soon. To keep using these features, consider changing your plan from Standard to Premium.',
		description: 'Description for the Premium landing page.',
	},
	bannerAccordionExpand: {
		id: 'servicedesk-premium-landing-page.banner.accordion.expand',
		defaultMessage: 'Expand',
		description: 'Expand button for the banner accordion',
	},
	bannerAccordionCollapse: {
		id: 'servicedesk-premium-landing-page.banner.accordion.collapse',
		defaultMessage: 'Collapse',
		description: 'Collapse button for the banner accordion',
	},
	tryItFreeButtonLabel: {
		id: 'servicedesk-premium-landing-page-trigger-banner.ui.try-it-free-button-label',
		defaultMessage: 'Try Premium for free',
		description: 'Label for the try it free button in the Premium landing page.',
	},
});
